export default __webpack_public_path__ + "static/media/img1.cac33bad.jpg";